import type {
  CoverageRule,
  CoverageResult,
  ServiceId,
  BaseTierId,
} from "./types"
import { findPackage, type InsurersData } from "./insurers"

/** Maps a recommended base tier to the insurer-coverage ServiceId. */
export const TIER_TO_SERVICE: Record<BaseTierId, ServiceId> = {
  blood_only: "blood-test",
  advanced_mri: "advanced-mri",
  pro_mri: "pro-mri",
}

export function calculateReimbursement(
  servicePrice: number,
  rule: CoverageRule
): number {
  const raw = (servicePrice * rule.percentage) / 100
  return Math.round(Math.min(raw, rule.max))
}

export function resolveCoverageState(
  data: InsurersData,
  insurerId: string,
  packageId: string,
  serviceId: ServiceId,
  locale: "de" | "en" | "fr" = "de"
): CoverageResult {
  const pkg = findPackage(data, insurerId, packageId)
  if (!pkg) return { state: "unknown" }

  const rule = pkg.coverage[serviceId]
  if (!rule) return { state: "unknown" }

  if (rule.percentage === 0 || rule.max === 0) {
    return { state: "not_covered", notes: pickNotes(rule, locale) }
  }

  const service = data.services.find((s) => s.id === serviceId)
  const amount = service
    ? calculateReimbursement(service.price, rule)
    : undefined

  return { state: "known", amount, notes: pickNotes(rule, locale) }
}

function pickNotes(
  rule: CoverageRule,
  locale: "de" | "en" | "fr"
): string | undefined {
  if (locale === "en") return rule.notes_en ?? rule.notes_de
  if (locale === "fr") return rule.notes_fr ?? rule.notes_de
  return rule.notes_de
}
